import React, { Component } from 'react';

import Aux from '../../../hoc/_Aux';
import Backdrop from '../../../containers/UI/Backdrop/Backdrop';

import './Modal.css';

class Modal extends Component{

    // EBE for improving performance in BurgerBuilder.js when modal is not shown, there is not need to redraw this component
    shouldComponentUpdate(nextProps, nextState){
        // EBE note : this.props.children is used for the Spinner to be displayed
        return nextProps.show !== this.props.show || nextProps.children !== this.props.children;
    }

    render(){
        return(
            <Aux>
            <Backdrop show={this.props.show} clicked={this.props.modalClosed} />
            <div
                className={`modal-panel ${this.props.class}`}
                style={{
                    transform: this.props.show ? 'translateY(0)' : 'translateY(-100vh)',
                    opacity: this.props.show ? '1' : '0'
                }}>
                {this.props.children}
            </div>
        </Aux>
        )
    }
 
}

export default Modal;


// WEBPACK FOOTER //
// ./src/components/UI/Modal/Modal.js